import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import marketplaceApiClient, { IndustryEntity } from 'api/marketplaceApiClient';
import { RootState } from './rootReducer';

interface QualificationState {
  industries: IndustryEntity[];
  isIndustriesLoading: boolean;
}

const initialState: QualificationState = {
  industries: [],
  isIndustriesLoading: false,
};

const getAllIndustries = createAsyncThunk(
  'qualification/getAllIndustries',
  async () => {
    return await marketplaceApiClient.getListIndustries();
  },
  {
    condition: (_, { getState }) => {
      const { qualification } = getState() as RootState;

      return !qualification.industries.length;
    },
  },
);

const qualificationSlice = createSlice({
  name: 'qualification',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllIndustries.fulfilled, (state, action) => {
      state.industries = action.payload;
      state.isIndustriesLoading = false;
    });
    builder.addCase(getAllIndustries.pending, (state, action) => {
      state.isIndustriesLoading = true;
    });
    builder.addCase(getAllIndustries.rejected, (state, action) => {
      state.isIndustriesLoading = false;
    });
  },
});

const { reducer } = qualificationSlice;

export { getAllIndustries };
export default reducer;
